<template>
  <section>
    <h2 class="h2Title">배너 등록</h2>
    <div class="formInfo">
      <v-form ref="formBanner">
        <dl class="infoCont">
          <dt class="formInfoTxt small">제목 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-text-field v-model="banner.title" :rules="[rules.required]" label="" dense flat clearable/>
            </v-col>
          </dd>
        </dl>
        <dl class="infoCont">

          <dt class="formInfoTxt small">배너 이미지 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea">
            <v-col class="d-flex">
              <v-col class="mgr" sm="6">
                <vue-dropzone
                    ref="bannerImageDropzone"
                    id="dropzone"
                    :options="dropzoneOptions"
                    :useCustomSlot="true"
                    @vdropzone-complete="imageUploadCompleteSuccess"
                    @vdropzone-success="imageUploadSuccess"
                    @vdropzone-removed-file="imageRemove"
                >
                  <div v-if="banner.bannerImage">
                    <v-badge
                        bordered
                        dark
                        color="black"
                        icon="mdi-delete"
                        overlap
                        @click.native="imageRemove"
                    >
                      <img :src="`${staticPath}/banner/${banner.bannerImage}`">
                    </v-badge>
                  </div>
                  <div class="dropzone-custom-content" v-else>
                    <h3 class="dropzone-custom-title">배너 이미지</h3>
                    <div class="subtitle">Drag and drop or click to select a file from your computer</div>
                  </div>
                </vue-dropzone>
              </v-col>
              <v-col class="mgr" sm="6" v-if="uploadedFile">
                <ul>
                  <li>
                    크기 : {{ uploadedFile.width }} x {{ uploadedFile.height }}
                  </li>
                  <li>
                    용량 : {{ uploadedFile.size / 1024 }} KB
                  </li>
                  <li>
                    형식 : {{ uploadedFile.type }}
                  </li>
                  <li>
                    <v-btn class="vBtn mgr" @click="imageVisible = true">
                      <v-icon left>search</v-icon>
                      크게 보기
                    </v-btn>
                  </li>
                </ul>
                <v-dialog v-model="imageVisible" max-width="800px" @click:outside="imageVisible = false" @keydown.esc="imageVisible = false">
                  <v-card>
                    <v-card-text>
                      <v-container>
                        <img :src="`${staticPath}/banner/${banner.bannerImage}`" />
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-col>
          </dd>
        </dl>

        <dl class="infoCont">
          <dt class="formInfoTxt small">이미지 설명</dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-text-field v-model="banner.alt" label="" dense flat clearable/>
            </v-col>
          </dd>
        </dl>

        <dl class="infoCont">
          <dt class="formInfoTxt small">배너 링크 주소</dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-text-field v-model="banner.url" label="" dense flat clearable/>
            </v-col>
          </dd>
        </dl>


        <dl class="infoCont">
          <dt class="formInfoTxt small">노출 여부</dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="3">
              <v-switch
                  v-model="banner.activated"
                  flat
                  color="primary"
                  :label="banner.activated ? '노출' : '미노출'"
              ></v-switch>
            </v-col>
          </dd>
        </dl>
      </v-form>
    </div>
    <div class="btnStyleBx">
      <div class="btnCommon justify-center">
        <v-btn class="vBtn" color="#1991eb" dark @click="save">
          <v-icon left>mdi mdi-content-save</v-icon>
          저장
        </v-btn>
        <v-btn class="vBtn" color="#fafafa" @click="goList()">
          <v-icon left>mdi mdi-format-list-bulleted</v-icon>
          목록
        </v-btn>
      </div>
    </div>
  </section>
</template>

<script>
import bannerApi from '@/api/BannerApi'

// import _ from 'lodash';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: "BannerForm",
  props: {
    id: String
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  data: () => ({
    imageVisible : false,
    rules: {
      required: value => !!value || '필수 입력 항목입니다..'
    },
    banner: {
      title: null,
      alt: null,
      activated: true
    },
    imageFileUrl: null,
    staticPath: process.env.VUE_APP_ATTACH_STATIC_PATH,
    fileMeta: {},
    // dropzoneOptions: {
    //   url: `${process.env.VUE_APP_BASE_API}/banner/upload/image`,
    //   thumbnailWidth: 550,
    //   maxFilesize: 0.5,
    //   maxFiles:2,
    //   acceptedFiles: "image/*",
    //   uploadMultiple: false,
    //   clickable: true,
    //   addRemoveLinks: true
    // },
    uploadedFile:null
  }),
  computed: {
    dropzoneOptions() {
      return {
        url: `${process.env.VUE_APP_BASE_API}/banner/upload/image`,
        thumbnailWidth: 550,
        maxFilesize: 10,
        maxFiles:2,
        acceptedFiles: "image/*",
        uploadMultiple: false,
        clickable: true,
        addRemoveLinks: true,
        headers: {
          'Authorization': `bearer ${this?.$store?.getters?.token ?? ''}`
        }
      }
    }
  },
  methods: {
    imageUploadSuccess(file, response) {
      const rejectedFiles = this.$refs.bannerImageDropzone.getRejectedFiles()
      for (const f of rejectedFiles) {
        this.$refs.bannerImageDropzone.removeFile(f);
      }

      const acceptedFiles = this.$refs.bannerImageDropzone.getAcceptedFiles()
      for (const f of acceptedFiles) {
        if(f !== file)
          this.$refs.bannerImageDropzone.removeFile(f);
      }

      this.banner.bannerImage = response.saveName;
      this.uploadedFile = file;
    },
    imageUploadCompleteSuccess(response) {

      if(!response.accepted) {
        const acceptedFiles = this.$refs.bannerImageDropzone.getAcceptedFiles()
        const rejectedFiles = this.$refs.bannerImageDropzone.getRejectedFiles()
        const allFile = [...acceptedFiles, ...rejectedFiles]
        for (const f of allFile) {
          if(f !== response) {
            this.$refs.bannerImageDropzone.removeFile(f);
          }
        }
      }
    },
    imageRemove() {
      this.banner.bannerImage = null;
      this.uploadedFile = null;
    },
    goList() {
      this.$router.push({path: `/banner/${this.$route.params.bannerCategory}`})
    },
    async save() {

      if(!this.banner.bannerImage) {
        alert("배너 이미지를 등록해주세요.");
        return
      }
      if (!await this.$refs.formBanner.validate())
        return;

      bannerApi.save(this.banner).then(data => {
        if (data) {
          if (this.banner.bannerId) {
            alert("수정되었습니다.");
          } else {
            alert("등록되었습니다.");
          }
          this.goList();
        } else {
          alert("Error");
        }
      });
    }

  },
  created() {
    if (this.$route.params.bannerId) {
      bannerApi.get(this.$route.params.bannerId).then(data => {
        // console.log(data);
        this.banner = data;
      });
    }

    this.banner.bannerCategory = this.$route.params.bannerCategory;

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.formInfo {
  @include form-info;
}

.userDd {
  padding: 10px 0;
}

.list {
  overflow: hidden;
}
</style>